import Swal from 'sweetalert2';
import { api } from '../../../api/api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = 'users';

const LOADER_USER = 'LOADER_USER';
const SET_DATA_USER = 'SET_DATA_USER';
const SET_PAGE_USER = 'SET_PAGE_USER';
const SET_UPDATE_DATA_USER ='SET_UPDATE_DATA_USER';
const SET_BUSCADOR_USER = 'SET_BUSCADOR_USER';
const SET_FILTRO_USER = 'SET_FILTRO_USER';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_USER, cargando: true});
    const store = getStore();
    const search = store.usuario.buscador;
    const filtro = store.usuario.filtro_user;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_USER, cargando: false});
        Swal(
            'Error',
            (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_USER, data});
            dispatch({type: SET_PAGE_USER, page});
        }
        dispatch({type: LOADER_USER, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_USER, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_USER, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/admin_usuario'))
        }
    }).then((data) => {
        dispatch({type: LOADER_USER, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_USER, updateData: data});
            dispatch(initializeForm('usuario', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.usuario.values;
    dispatch({type: LOADER_USER, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_USER, cargando: false})
        Swal('Éxito', 'Se ha creado el usuario.', 'success')
        .then(() => {
            dispatch(push('/admin_usuarios'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_USER, cargando: false})
        Swal(
            'Error',
             (error && error.detail) ? error.detail : 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_USER, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.usuario.values);
    dispatch({type: LOADER_USER, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_USER, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/admin_usuarios'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_USER, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/admin_usuarios'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_USER, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_USER, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_USER, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}



const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_USER, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_USER, filtro_user: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_USER]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_USER]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_USER]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_USER]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_USER]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_USER]: (state, { filtro_user }) => {
        return {...state, filtro_user }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_user: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
